import { render } from "./LayoutSquared.vue?vue&type=template&id=3ab0ddf6&scoped=true"
import script from "./LayoutSquared.vue?vue&type=script&lang=js"
export * from "./LayoutSquared.vue?vue&type=script&lang=js"

import "./LayoutSquared.vue?vue&type=style&index=0&id=3ab0ddf6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab0ddf6"]])

export default __exports__